<template>
    <div>
        <!--HEADER NAVBAR START-->
        <SiteHeader style="width: 100%"></SiteHeader>
        <NavbarStatic style="width: 100%"></NavbarStatic>
        <!--HEADER NAVBAR END-->

        <!--CONTENTS START-->
        <div style="margin-bottom: 50px;">
            <template v-if="featured.length > 0">
                <!-- <el-carousel :interval="6500" indicator-position="outside" :height="isWindowOnDesktop ? '900px' : '250px'">
                    <template v-for="(ft, index) in featured">
                        <el-carousel-item>
                            <div class="carousel-item-container">
                                <img :src="ft.pictures[0].full_path" class="carousel-image" />
                                <div class="carousel-overlay">
                                    <div class="carousel-text">
                                        <h4 class="carousel-featured">FEATURED</h4>
                                        <h2 class="carousel-title">{{ ft.title }}</h2>
                                        <p class="carousel-author">By {{ ft.author }} | {{ ft.date }}</p>
                                        <a :href="env_wp.APP_URL+'/news/featured/'+ft.slug" class="carousel-read-more">Read more <i class="fa fa-arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </el-carousel-item>
                    </template>
                </el-carousel> -->

                <div id="featuredCarousel" class="carousel slide" data-ride="carousel">
                    <div class="carousel-inner">
                        <div v-for="(ft, index) in featured" :key="index" :class="['carousel-item', { active: index === 0 }]">
                            <template v-if="ft.slug !== ''">
                                <img :src="ft.pictures[0].full_path" class="carousel-image" :style="isWindowOnDesktop ? 'height: 800px;' : 'height: auto;'">
                                <div class="carousel-overlay" :style="isWindowOnDesktop ? '' : 'padding-bottom: 0px;'">
                                    <div class="carousel-text">
                                        <template v-if="isWindowOnDesktop">
                                            <h4 class="carousel-featured">FEATURED</h4>
                                            <h2 class="carousel-title">{{ ft.title }}</h2>
                                            <p class="carousel-author">By {{ ft.author }} | {{ ft.date }}</p>
                                            <a :href="env_wp.APP_URL+'/news/featured/'+ft.slug" class="carousel-read-more">Read more <i class="fa fa-arrow-right"></i></a>
                                        </template>
                                        <template v-else>
                                            <h4 class="carousel-featured-mobile">FEATURED</h4>
                                            <h4 class="carousel-title-mobile">{{ ft.title }}</h4>
                                            <p class="carousel-author-mobile">By {{ ft.author }} | {{ ft.date }}</p>
                                            <a :href="env_wp.APP_URL+'/news/featured/'+ft.slug" class="carousel-read-more-mobile">Read more <i class="fa fa-arrow-right"></i></a>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <a class="carousel-control-prev" href="#featuredCarousel" role="button" data-slide="prev" style="height: 400px; margin-top: 200px;">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#featuredCarousel" role="button" data-slide="next" style="height: 400px; margin-top: 200px;">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
            </template>
            <template v-else>
                <br>
                <br>
                <center>There is no Featured Content yet.</center>
            </template>
        </div>

        <div style="margin-bottom: 50px;">
            <!--<div class="whats-happening"></div>--> <!-- BANNER -->
            <img :src="env_wp.APP_URL+'/public/assets/img/ssa_manila/news_page/banners/What_s_Happening_BANNER.jpg'" style="width: 100%;">
            <div class="container-fluid">
                <!-- <h1 class="ssa-text-color">WHAT'S HAPPENING AT ST. SCHO</h1> -->
                <br>
                <br>
                <template v-if="whats_happening.length > 0">
                    <div class="carousel-container">
                        <el-carousel :interval="6500" indicator-position="outside" :height="isWindowOnDesktop ? '400px' : '250px'">
                            <template v-for="(wh, index) in whats_happening">
                                <el-carousel-item>
                                    <div class="happening-item">
                                        <img :src="wh.pictures[0].full_path" class="happening-image" />
                                        <div class="happening-content">
                                            <h2 class="ssa-text-color">{{ wh.title }}</h2>
                                            <p class="happening-author ssa-text-color">{{ wh.author }} | {{ wh.date }}</p>
                                            <a :href="env_wp.APP_URL+'/news/happening/'+wh.slug" class="happening-read-more">Read more <i class="fa fa-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </template>
                        </el-carousel>
                    </div>
                </template>
                <template v-else>
                    <center>There is no What's Happening Content yet.</center>
                </template>
            </div>
        </div>

        <div style="margin-bottom: 50px;">
            <img :src="env_wp.APP_URL+'/public/assets/img/ssa_manila/news_page/banners/Upcoming_Events_BANNER.jpg'" style="width: 100%;">
            <!--<div class="upcoming-banner"></div>--> <!-- BANNER -->
            <div class="container-fluid">
                <!-- <h1 class="ssa-text-color">UPCOMING EVENTS</h1> -->
                <br>
                <br>
                <template v-if="upcoming_events.length > 0">
                    <div class="upcoming-events-container">
                        <div class="events-list">
                            <div v-for="(event, index) in upcoming_events" :key="index" class="event-item">
                                <div class="event-date">
                                    <h2 class="event-day">{{ event.day }}</h2>
                                    <p class="event-month">{{ event.month }}</p>
                                </div>
                                <img :src="event.pictures[0].thumbnail_path" class="event-image" />
                                <div class="event-details">
                                    <h1 class="ssa-text-color">{{ event.title }}</h1>
                                    <p class="event-description">{{ event.description }}</p>
                                    <div class="event-footer">
                                        <template v-if="event.type == 1">
                                            <a :href="env_wp.APP_URL+'/news/upcoming/'+event.slug" class="learn-more">Learn more</a>
                                            <a :href="env_wp.APP_URL+'/news/upcoming/'+event.slug" class="facebook-link">
                                                <i class="fa fa-arrow-right"></i>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a :href="event.link" class="learn-more" target="_blank">Learn more</a>
                                            <a :href="event.link" class="facebook-link" target="_blank">
                                                <i class="fa fa-facebook"></i>
                                            </a>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <center>There is no Upcoming Events Content yet.</center>
                </template>
            </div>
        </div>
        <!--CONTENTS END-->

        <!--FOOTER START-->
        <div style="margin-top: 20px; margin-bottom: 20px;">
            <div class="row no-gutters" :style="!isWindowOnDesktop ? 'margin-left: 0; margin-right: 0;' : ''">
                <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" style="padding-right: 0px;">
                    &nbsp;
                </div>
                <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" :style="!isWindowOnDesktop ? 'padding-right: 0px;' : ''">
                    <button @click="scrollToTop()" class="btn btn-ssa pull-right"><span style="font-family: Arial; font-size: 2rem; color: #ffffff;"><strong><i class="fa fa-angle-double-up" aria-hidden="true"></i>Back to Top</strong></span></button>
                </div>
            </div>
        </div>
        
        <div style="background: #012376;">
            <div class="row" style="margin-right: 0%;">
                &nbsp;
            </div>
        </div>
        <SiteFooter :style="{backgroundImage: `url('${env_wp.APP_URL}/public/assets/img/ssa_manila/hompage/footer_assets/comp/footer_backdrop.png')`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', position: 'relative', width: '100%'}"></SiteFooter>
        <!--FOOTER END-->
    </div>
</template>
<style scoped>
    .carousel-item-container {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    /* Carousel Image */
    .carousel-image {
        width: 100%;
        height: 100%;
        object-fit: fill;
    }

    /* Overlay */
    .carousel-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8));
        display: flex;
        align-items: flex-end; /* Align text to the bottom */
        justify-content: flex-start;
        padding: 40px 20px; /* Increase top padding to move text lower */
        box-sizing: border-box;
    }

    /* Text Container */
    .carousel-text {
        color: #012376;
        max-width: 50%;
    }

    /* Featured Label */
    .carousel-featured {
        font-size: 1.2rem;
        font-weight: bold;
        color: #012376;
        margin-bottom: 10px;
    }

    .carousel-featured-mobile {
        font-size: 1rem;
        font-weight: bold;
        color: #012376;
        /* margin-bottom: 10px; */
    }

    /* Title */
    .carousel-title {
        font-size: 2rem;
        font-weight: bold;
        line-height: 1.4;
        margin-bottom: 15px;
    }

    .carousel-title-mobile {
        font-size: 0.8rem;
        font-weight: bold;
        /* line-height: 1.4; */
        margin-bottom: 5px;
        width: 295px;
    }

    /* Author and Date */
    .carousel-author {
        font-size: 1rem;
        margin-bottom: 20px;
        color: #012376;
    }

    .carousel-author-mobile {
        font-size: 0.7rem;
        margin-bottom: 10px;
        color: #012376;
    }

    /* Read More Link */
    .carousel-read-more {
        font-size: 1rem;
        font-weight: bold;
        color: #012376;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
    }

    .carousel-read-more-mobile {
        font-size: 0.7rem;
        font-weight: bold;
        color: #012376;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
    }

    .carousel-read-more i {
        margin-left: 5px;
        font-size: 1rem;
    }

    .el-carousel__item h3 {
        display: block;
        color: #012376;
        opacity: 5;
        line-height: 300px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #012376;
    }

    .el-carousel__item:nth-child(2n + 1) {
        background-color: #012376;
    }
    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: auto;
        height: auto;
        background-color: #012376;
        border-radius: 20px;
        opacity: 75%;
    }

    .centered-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-size: 16px;
        font-weight: bold;
        z-index: 1;
    }
    .btn-ssa{
        background-color: #012376;
    }

    .image-container {
        -webkit-mask-image: linear-gradient(to bottom, white 0%, transparent 100%);
       mask-image: linear-gradient(to bottom, white 0%, transparent 100%);
       -webkit-mask-size: 100% 100%;
       mask-size: 100% 100%;
       -webkit-mask-repeat: no-repeat;
       mask-repeat: no-repeat;
    }

    .overlay {
       -webkit-mask-image: linear-gradient(to bottom, white 0%, white 100%, transparent 100%);
       mask-image: linear-gradient(to bottom, white 0%, white 100%, transparent 100%);
       -webkit-mask-size: 100% 100%;
       mask-size: 100% 100%;
       -webkit-mask-repeat: no-repeat;
       mask-repeat: no-repeat;
    }

    .carousel-container {
        margin-top: 20px;
        margin-bottom: 50px;
        text-align: center;
    }

    .section-title {
        font-size: 2rem;
        font-weight: bold;
        color: #012376;
        margin-bottom: 20px;
    }

    .happening-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #f8fafc;
        /* border-radius: 0px; */
        overflow: hidden;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        padding: 20px;
    }

    .happening-image {
        width: 50%;
        height: auto;
        /* border-radius: 10px; */
        object-fit: cover;
    }

    .happening-content {
        width: 45%;
        text-align: left;
        padding: 20px;
    }

    .happening-title {
        font-size: 1.5rem;
        font-weight: bold;
        color: #012376;
        margin-bottom: 10px;
    }

    .happening-author {
        font-size: 1rem;
        /* color: #555555; */
        margin-bottom: 20px;
    }

    .happening-read-more {
        font-size: 1rem;
        font-weight: bold;
        color: #012376;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
    }

    .happening-read-more i {
        margin-left: 5px;
        font-size: 1rem;
    }

    .upcoming-events-container {
        margin-top: 20px;
        margin-bottom: 50px;
        text-align: center;
    }

    .section-title {
        font-size: 2rem;
        font-weight: bold;
        color: #012376;
        margin-bottom: 20px;
    }

    .events-list {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .event-item {
        display: flex;
        align-items: center;
        background-color: #ffffff;
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        padding: 20px;
    }

    .event-date {
        background-color: #012376;
        color: #ffffff;
        text-align: center;
        padding: 10px 20px;
        border-radius: 10px;
        margin-right: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-width: 80px;
    }

    .event-day {
        font-size: 2rem;
        font-weight: bold;
        margin: 0;
    }

    .event-month {
        font-size: 1rem;
        text-transform: uppercase;
        margin: 0;
    }

    .event-details {
        flex: 1;
        text-align: left;
    }

    .event-title {
        font-size: 1.5rem;
        font-weight: bold;
        color: #012376;
        margin-bottom: 10px;
    }

    .event-description {
        font-size: 1rem;
        color: #555555;
        margin-bottom: 20px;
    }

    .event-footer {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .learn-more {
        font-size: 1rem;
        font-weight: bold;
        color: #012376;
        text-decoration: none;
    }

    .facebook-link {
        font-size: 1.5rem;
        color: #012376;
        text-decoration: none;
    }
    .event-image {
        height: auto;
        width: auto;
        padding-left: 25px;
        padding-right: 25px;
    }

    .whats-happening {
        position: relative;
        background: url('/ssamanila_site_v2/public/assets/img/ssa_manila/news_page/banners/What_s_Happening_BANNER.jpg') no-repeat center center;
        /*https://ssamanilademo.orangeapps.ph/ssamanila_site/public/assets/img/ssa_manila/student_life/top_banner.png*/
        background-size: cover;
        color: white;
        text-align: center;
        padding: 50px 0;
        height: 225px;
        width: 90%;
        max-width: 1350px;
        margin: 0 auto;
    }
    .whats-happening::before {
        content: '';
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        /*background: linear-gradient(rgba(1, 35, 118, 0.7), rgba(1, 35, 118, 0.7));*/
        z-index: 1;
    }
    .whats-happening h1 {
        position: relative;
        z-index: 2;
        font-size: 2.5rem;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .upcoming-banner {
        position: relative;
        background: url('/ssamanila_site_v2/public/assets/img/ssa_manila/news_page/banners/Upcoming_Events_BANNER.jpg') no-repeat center center;
        /*https://ssamanilademo.orangeapps.ph/ssamanila_site/public/assets/img/ssa_manila/student_life/top_banner.png*/
        background-size: cover;
        color: white;
        text-align: center;
        padding: 50px 0;
        height: 225px;
        width: 90%;
        max-width: 1350px;
        margin: 0 auto;
    }
    .upcoming-banner::before {
        content: '';
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        /*background: linear-gradient(rgba(1, 35, 118, 0.7), rgba(1, 35, 118, 0.7));*/
        z-index: 1;
    }
    .upcoming-banner h1 {
        position: relative;
        z-index: 2;
        font-size: 2.5rem;
        font-weight: bold;
        margin-bottom: 20px;
    }

</style>
<script>
    import NavbarStatic from "../../../components/general/NavbarStatic";
    import SiteHeader from "../../../components/general/SiteHeader";
    import SiteFooter from "../../../components/general/SiteFooter";
import { env } from "process";
    export default {
        props: {
            resources: Array
        },
        components: { NavbarStatic,SiteHeader,SiteFooter },
        data () {
            return {
                folder_name: this.$root.folder_name,
                env_wp: this.$root.env_wp.env_wp,
                screenWidth: window.innerWidth,
                isWindowOnDesktop: window.innerWidth > 768,
                featured: [],
                whats_happening: [],
                upcoming_events: [],
            }
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            });
            this.onResize();
            this.getContents();
        },
        created() {

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        watch: {
            screenWidth(width) {
                this.isWindowOnDesktop = width > 768;
            },
        },
        methods: {
            scrollToTop(){
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            },
            onResize() {
                this.screenWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            },
            getContents(){
                axios.get(this.env_wp.APP_URL + '/news_data/get_contents')
                .then(res => {
                    this.featured = res.data.featured;
                    this.whats_happening = res.data.whats_happening;
                    this.upcoming_events = res.data.upcoming_events;
                })
                .catch(err => {
                    console.log(err);
                });
            },
        }
    }
</script>